var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocs = function SvgDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 0L29 8.6V32H3V0h17.4zm.6 3.4V8h4.6L21 3.4zM5 30h22V10h-8V2H5v28zm4-14v-2h14v2H9zm0 4v-2h14v2H9zm0 4v-2h14v2H9z",
    fill: "#000",
    fillRule: "evenodd"
  })));
};
export default SvgDocs;